export enum REACTION_COMMENT {
  I_HAVE_BEEN_THERE_BEFORE = 'I`ve been there before',
  I_DONT_LIKE_THIS_PLACE = 'I don`t like this place',
}
